module.exports = __webpack_public_path__ + "static/media/as7tj93.e884cef7.png";